/**
 * Shared contract for clinical rich text that must render consistently in the
 * pathologist editor, report preview, and captured/PDF report.
 */
export const CLINICAL_RICH_TEXT_CLASS = "clinical-rich-text";
export const ADDENDUM_RICH_TEXT_CLASS = "addendum-rich-text";

export const CLINICAL_RICH_TEXT_PARSE_OPTIONS = {
  preserveWhitespace: "full" as const,
};

export const CLINICAL_RICH_TEXT_COLORS = [
  "#000000",
  "#868e96",
  "#fa5252",
  "#e64980",
  "#be4bdb",
  "#7950f2",
  "#4c6ef5",
  "#228be6",
  "#15aabf",
  "#12b886",
  "#40c057",
  "#82c91e",
  "#fab005",
  "#fd7e14",
];

/**
 * Addendum paragraphs are report lines, not browser-spaced prose blocks. This
 * restores the legacy geometry without changing any authored inline content.
 */
export const ADDENDUM_RICH_TEXT_STYLES = `
  .${CLINICAL_RICH_TEXT_CLASS}.${ADDENDUM_RICH_TEXT_CLASS},
  .${ADDENDUM_RICH_TEXT_CLASS} .ProseMirror {
    line-height: 1.15;
  }

  .${CLINICAL_RICH_TEXT_CLASS}.${ADDENDUM_RICH_TEXT_CLASS} p,
  .${ADDENDUM_RICH_TEXT_CLASS} .ProseMirror p {
    margin: 0;
  }

  .${CLINICAL_RICH_TEXT_CLASS}.${ADDENDUM_RICH_TEXT_CLASS} p:empty,
  .${ADDENDUM_RICH_TEXT_CLASS} .ProseMirror p:empty {
    min-height: 1.15em;
  }
`;

/**
 * These rules are intentionally scoped to opted-in clinical-rich-text roots.
 * Existing report geometry and ordinary paragraph spacing remain unchanged;
 * only authored whitespace and genuinely empty paragraphs gain a visible
 * representation.
 */
export const CLINICAL_RICH_TEXT_STYLES = `
  .${CLINICAL_RICH_TEXT_CLASS},
  .${CLINICAL_RICH_TEXT_CLASS} * {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .${CLINICAL_RICH_TEXT_CLASS} {
    white-space: pre-wrap;
    white-space: break-spaces;
    tab-size: 4;
    overflow-wrap: break-word;
  }

  .${CLINICAL_RICH_TEXT_CLASS} p:empty {
    min-height: 1.6em;
  }

  ${ADDENDUM_RICH_TEXT_STYLES}
`;
